import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconFlag } from './icons';

interface BookmarkToggleButtonProps {
  isFlagged: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
}

export function BookmarkToggleButton({ isFlagged, onClick, className = 'feed-item-action-btn' }: BookmarkToggleButtonProps) {
  const navigate = useNavigate();
  const [contextMenuOpen, setContextMenuOpen] = useState(false);
  const label = isFlagged ? 'Unflag' : 'Flag';

  return (
    <span
      className="flag-action-menu"
      onContextMenu={(e) => { e.preventDefault(); setContextMenuOpen(true); }}
    >
      <button
        className={`${className}${isFlagged ? ' flagged' : ''}`}
        onClick={onClick}
        title={`${label} (f)`}
      >
        <IconFlag filled={isFlagged} />
      </button>
      <span className={`flag-action-menu-popover${contextMenuOpen ? ' context-open' : ''}`} role="menu">
        <button type="button" role="menuitem" onClick={(e) => { e.stopPropagation(); onClick(e); setContextMenuOpen(false); }}>
          {label}
        </button>
        <button type="button" role="menuitem" onClick={(e) => { e.stopPropagation(); navigate('/flagged'); setContextMenuOpen(false); }}>
          View flagged stories
        </button>
      </span>
    </span>
  );
}
